import React from 'react';
import PropTypes from 'prop-types';

const ImageRenderer = ({ source, id, description }) => {
  return <img id={id} className="img-sliders" src={source} alt={description} />;
};

ImageRenderer.propTypes = {
  source: PropTypes.string,
  id: PropTypes.number,
  description: PropTypes.string,
};

export default ImageRenderer;
